import Footer from "components/Footer/FooterCustom.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    categories: state.categories,
    city: state.city,
    attributes: state.attributes,
    user: state.user
  };
}

const FooterContainer = connectFunction(mapStateToProps)(Footer);
export default FooterContainer;
